export default "__VITE_ASSET__CHFvVCtN__"